import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';
    import { Trash2 } from 'lucide-vue-next';
    import { useViewOptionsStore } from '@/stores/view-options';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';

    interface Props {
        viewOptionId: number;
        disabled?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ViewOptionDelete',
  props: {
    viewOptionId: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const viewOptionsStore = useViewOptionsStore();

    const { t } = useI18n();

    const props = __props;

    const mutation = useMutation({
        mutationFn: async () => {
            return await axios.delete(
                route('v2.dashboard.view-options.destroy', props.viewOptionId),
            );
        },
        onSuccess: () => {
            viewOptionsStore.deleteViewOption(props.viewOptionId);
        },
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "delete",
            size: "icon_sm",
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Trash2))
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.delete_confirmation.header')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.delete_confirmation.description')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.delete_confirmation.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mutation).mutate()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.delete_confirmation.continue')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})